import mockAxios, { AxiosResponse } from 'axios';

import { ITimeOffCalendarServiceMock } from './timeoff-calendar.mock.types';

export const mockTimeOffCalendarService = (): ITimeOffCalendarServiceMock => ({
  fetchTimeOffCalendars: jest.fn(),
  fetchTimeOffCalendar: jest.fn(),
  createTimeOffCalendar: jest.fn(),
  updateTimeOffCalendar: jest.fn(),
  deleteTimeOffCalendar: jest.fn(),

  //holiday
  fetchCalendarHolidays: jest.fn(),
  fetchCalendarHoliday: jest.fn(),
  createCalendarHoliday: jest.fn(),
  updateCalendarHoliday: jest.fn(),
  deleteCalendarHoliday: jest.fn(),
  uploadCalendarHolidays: jest.fn()
});

export const mockTimeOffCalendarAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
